<template>
  <svg :class="svgClass" aria-hidden="true" :style="style">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    className: {
      type: String,
    },
    color: {
      type: String,
      default: '#9D00CA',
    },
  },
  computed: {
    iconName() {
      // 使用 svg-sprite-loader 默认 symbol 命名：#icon-[name]
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },
    style() {
      return {
        '--color': this.color,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  color: var(--color);
}
</style>
